import styled from "styled-components";
import {Button, Card, Modal, Radio} from "antd";

export const DetailModal = styled(Modal)`
    .ant-modal-content {
        border-radius: 16px;
        overflow: hidden;
    }

    .ant-modal-header {
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
    }
`;

export const TitleRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 600;
`;

export const TitleIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background: #d4f0d8;
    color: #2f8f46;
    font-size: 14px;
`;

export const TicketNumber = styled.span`
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
`;

export const InfoBand = styled.div`
    display: flex;
    margin-bottom: 16px;
    padding: 16px 0;
    border-radius: 8px;
    background: ${({$background}) => $background};

    @media (max-width: 768px) {
        flex-wrap: wrap;
        row-gap: 16px;
    }
`;

export const InfoColumn = styled.div`
    display: flex;
    flex: 1 1 0;
    flex-direction: column;
    gap: 16px;
    min-width: 0;
    padding: 0 16px;

    & + & {
        border-left: 1px solid rgba(0, 0, 0, 0.08);
    }

    @media (max-width: 768px) {
        flex-basis: 50%;

        &:nth-child(odd) {
            border-left: none;
        }
    }
`;

export const InfoLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
`;

export const InfoValue = styled.div`
    margin-top: 4px;
    font-weight: 500;
`;

export const DescriptionBox = styled.div`
    padding: 12px 16px;
    border: 1px solid #d6e4ff;
    border-radius: 8px;
    background: #f0f7ff;
    white-space: pre-wrap;
    word-break: break-word;
`;

export const ImageList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
`;

export const ImageTile = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 112px;
    height: 84px;
    padding: 4px;
    overflow: hidden;
    border: 1px solid #d6e4ff;
    border-radius: 8px;
    background: #f0f7ff;

    .ant-image {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
    }
`;

export const SectionTitle = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
`;

export const SectionCard = styled(Card)`
    border: 1px solid #d6e4ff;
    border-radius: 8px;

    .ant-card-head {
        border-bottom: none;
    }
`;

export const AssignCard = styled(SectionCard)`
    background: #f5f9ff;

    .ant-card-body {
        padding-top: 0;
    }
`;

export const AssignedBand = styled(InfoBand)`
    align-items: center;
    margin-bottom: ${({$isEditing}) => ($isEditing ? "16px" : "0")};
    padding: 4px 0;
    border: 1px solid #bae0ff;

    ${InfoValue} {
        margin-top: 0;
    }
`;

export const EditToggle = styled(Button)`
    flex-shrink: 0;
    margin: 0 12px;
`;

export const ModeSwitch = styled(Radio.Group)`
    display: flex;
    gap: 8px;
    max-width: 560px;
    margin-bottom: 16px;

    .ant-radio-button-wrapper {
        flex: 1;
        height: 36px;
        border: 1px solid #d9d9d9;
        border-radius: 8px;
        line-height: 34px;
        text-align: center;

        &::before {
            display: none;
        }
    }

    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
        border-color: #1890ff;
        background: #e6f4ff;
    }
`;

export const FieldLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
    color: rgba(0, 0, 0, 0.65);
`;

export const SelfAssignRow = styled.div`
    display: flex;
    gap: 12px;

    > :first-child {
        flex: 1;
        min-width: 0;
    }

    @media (max-width: 576px) {
        flex-direction: column;
    }
`;

export const TargetRow = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 12px;

    @media (max-width: 576px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const TargetField = styled.div`
    flex: 1;
    min-width: 0;
`;

export const OrBadge = styled.span`
    flex-shrink: 0;
    padding: 2px 12px;
    margin-bottom: 4px;
    border-radius: 12px;
    background: #f0f5ff;
    color: #1d39c4;
    font-size: 12px;
    font-weight: 500;

    @media (max-width: 576px) {
        align-self: center;
        margin-bottom: 0;
    }
`;

export const ActionRow = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
`;
